import { parse } from 'marked'

import css from './Table.module.css'

const rowProps = ['row1', 'row2', 'row3', 'row4', 'row5', 'row6', 'row7', 'row8']

export default function Table({ columns }) {
    /** Compute the number of rows */
    const [firstCol] = columns
    const numberOfRows = rowProps.findIndex((prop) => !firstCol[prop])
    return (
        <table className={css.table}>
            <thead>
                <tr>
                    {columns.map((col) => (
                        <th key={col.title}>{col.title}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rowProps.slice(0, numberOfRows).map((prop, index) => (
                    <tr key={prop + index}>
                        {columns.map((col) => (
                            <td
                                key={col[prop]}
                                dangerouslySetInnerHTML={{ __html: parse(col[prop]) }}
                            />
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
